import { useState } from 'react';
import { PLANS_DEFAULT_SORT } from 'config/quotes';
import { calcMinEffectiveDate, humanFormatEffectiveDate } from 'utils/retail/plans';
import { CustomerType } from "../services/orders/types";

export type EnergyRatesQuery = Record<string, string | number>;
type Callback = (query: EnergyRatesQuery) => Promise<void>;

const useEnergyRates = (callback: Callback) => {
  const [query, setQuery] = useState<EnergyRatesQuery>({});

  const page = query.page ? Number(query.page) : 1;
  const sort = query.sort ? String(query.sort) : PLANS_DEFAULT_SORT;
  const minEffectiveDate = calcMinEffectiveDate();
  const effectiveDate = humanFormatEffectiveDate(
    query.effectiveDate ? new Date(String(query.effectiveDate)) : minEffectiveDate
  );
  const term = query.term ? String(query.term) : '';
  const utilityId = query.utilityId ? String(query.utilityId) : '';
  const customerType = query.customerType ? String(query.customerType) : CustomerType.RESIDENTIAL;

  const [isLoadingAllPlans, setIsLoadingAllPlans] = useState<boolean>(false);
  const [isLoadingBestPlans, setIsLoadingBestPlans] = useState<boolean>(false);

  const refresh = async (more: Record<string, string | number>, withBestPlans = true) => {
    const beforeY = window.pageYOffset;
    if (withBestPlans) {
      setIsLoadingBestPlans(true);
    }
    setIsLoadingAllPlans(true);
    const newQuery = { ...query, ...more };
    setQuery({ ...query, ...more });
    await callback(newQuery);
    setIsLoadingBestPlans(false);
    setIsLoadingAllPlans(false);
    window.scrollTo(0, beforeY);
  };

  return {
    isLoadingAllPlans,
    isLoadingBestPlans,
    page,
    sort,
    effectiveDate,
    refresh,
    minEffectiveDate,
    term,
    utilityId,
    customerType,
  };
};

export default useEnergyRates;
